import React from "react";
import Field from "./../../../components/Fields/Field";
import SelectListControl from "./../../../components/Fields/SelectListControl";
import { FieldProps } from "./../../../components/Fields/Types";
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import ItemEmployeeModel from '../../../models/ItemEmployeeModel';

interface ItemEmployeeFieldProps extends FieldProps {
    itemEmployee: ItemEmployeeModel
}

const ItemEmployeeField: React.FC<ItemEmployeeFieldProps> = ({ labelProps, controlProps, itemEmployee }) => {
    const employees = useSelectListOptions('api/v1/selectlist/EmployeesForFunctionalRole?functionalRoleId=' + itemEmployee.functionalRoleId, '-- Select employee', controlProps.value);

    return (
        <Field {...labelProps}>
            <SelectListControl {...controlProps} options={employees} />
        </Field>
    );
}
export default ItemEmployeeField;